__turbopack_context__.v({
  "body": "XA-CXG_body",
  "close": "XA-CXG_close",
  "content": "XA-CXG_content",
  "header": "XA-CXG_header",
});
